import ModalSeguimientoLead from 'akasia-components/leads/ModalSeguimientoLead';
import classNames from 'classnames';
import { useToast } from 'context/providers/ToastProvider';
import createMarkup from 'helpers/createMarkup';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row, } from 'react-bootstrap';
import InfiniteScroll from "react-infinite-scroll-component";
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router-dom';
import greetingImage from '../../assets/img/illustrations/logo_esfera_.fw.png';
import greetingsBg from '../../assets/img/illustrations/ticket-greetings-bg.png';
import Background from '../../components/common/Background';
import ImagenPerfil from '../../components/common/ImagenPerfil';

const NotificationItem = ({
    notification,
    setIdLead,
    setShowModalSeguimientoLead
}) => {

    const { token } = useToken();
    const { showErrorToast } = useToast();
    const objAction = JSON.parse(notification.vJsonAction);
    const navigate = useNavigate();

    //Maneja el click para abrir el modal de seguimiento de lead
    const clickToModalSeguimientoLead = (idLead) => {

        setIdLead(idLead);
        setShowModalSeguimientoLead(true);

        notification.bFueMostrado = true;
        marcarNotificacionComoMostrada(notification.idNotificacion);

    };
    const clickToUrl = () => {

        console.log("objAction: ", objAction);
        notification.bFueMostrado = true;
        marcarNotificacionComoMostrada(notification.idNotificacion);


        navigate(objAction.detalles.vUrl);
    };
    const marcarNotificacionComoMostrada = async (idNotificacion) => {

        var jDataSend = {};
        jDataSend.idNotificacion = idNotificacion;

        const response = await fetch("/api/account/MarcarNotificacionComoMostrada/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            console.log("==== NOTIFICACION MARCADA COMO MOSTRADA ====");

            console.log("response: ", response);

            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {
                //hayNotificacionesNoLeidas();
                //infoNoti.cantidadNoMostradas--;
                //CrearLbl();
            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);

            console.log(response);
        }
    }

    return (
        <div style={{ cursor: 'pointer', border: 'none', }}

            className={classNames(
                'p-1 shadow-none notification-item d-flex align-items-center rounded-0 ',
                { 'notification-unread': !notification.bFueMostrado }
            )}

            onClick={() => {
                //si va mostrar un modal entra aqui
                if (objAction.TypeAction == 1) {

                    //si es seguimiento lead va entrar aqui
                    if (objAction.detalles.idModalType == 1) {
                        clickToModalSeguimientoLead(objAction.detalles.data.idLead);
                    }
                }

                if (objAction.TypeAction == 2) {
                    //si es URL entra aqui
                    clickToUrl();
                }
            }
            }
        >
            {
                <div className="notification-avatar me-3 justify-items-center">
                    <ImagenPerfil idUsuario={notification.idUsuarioSource}></ImagenPerfil>
                </div>
            }
            <div className="notification-body" >
                <p className="mb-1" dangerouslySetInnerHTML={createMarkup(notification.vCuerpo)} />
                <span className="notification-time">
                    {notification.time}
                </span>
            </div>
        </div>
    );
};

const NotificationSection = ({
    setIdLead,
    setShowModalSeguimientoLead
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [notificaciones, setNotificaciones] = useState([]);
    const [lastNotf, setLastNotf] = useState(0);

    const obtenerNotificacionesPorCategoria = async () => {

        var jDataSend = {};
        jDataSend.idCatNotificacion = -1;
        jDataSend.lastNotification = lastNotf;
        jDataSend.iFirstNotification = 0;

        console.log(jDataSend);

        const response = await fetch("/api/account/obtenerNotificacionesPorCategoria/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {

            console.log("============ OBTENER NOTIFICACIONES ============");
            console.log("response notificaciones: ", response);
            const data = await response.json();
            console.log("data notificaciones: ", data);

            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);
                console.log("detalles: ", detalles);

                setNotificaciones(prevNotificaciones => [
                    ...prevNotificaciones,
                    ...detalles.table2
                ]);

                setLastNotf(detalles.table3[0].minimo);

            } else {
                console.log("Error: ", data.vMessage);
            }

        }
        else {
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    }

    const fetchMoreData = () => {
        obtenerNotificacionesPorCategoria();
    };

    useEffect(() => {
        obtenerNotificacionesPorCategoria();
    }, []);

    return (
        <>
            <Row className="card shadow-none border-bottom">
                <Col className=" col-12 p-0">
                    <Row id={"targetScrollNtf"} className="card-body p-1 overflow-auto m-0" style={{ height: 660 }} >
                        <Col className="notification-section col-12" >
                            {
                                <>
                                    <InfiniteScroll
                                        dataLength={notificaciones.length}
                                        next={fetchMoreData}
                                        hasMore={lastNotf ? true : false}
                                        loader={<NotificationSkeleton />}
                                        scrollableTarget={"targetScrollNtf"}
                                        scrollThreshold={0.99}
                                    >
                                        {
                                            notificaciones.map(notificacion => (
                                                <NotificationItem
                                                    key={notificacion.idNotificacion}
                                                    notification={notificacion}
                                                    setIdLead={setIdLead}
                                                    setShowModalSeguimientoLead={setShowModalSeguimientoLead}
                                                />
                                            ))
                                        }
                                    </InfiniteScroll>
                                </>

                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

const NotificationsPage = () => {

    const [showModalSeguimientoLead, setShowModalSeguimientoLead] = useState(false);
    const [idLead, setIdLead] = useState(0);

    useEffect(() => {
        //obtenerNotificaciones();
    }, []);

    return (
        <>

            <Row>

                <Col className="col-12 mb-3">

                    <Card className="bg-light shadow-none">
                        <Background image={greetingsBg} className="bg-card d-none d-sm-block" />
                        <Card.Header className="d-flex align-items-center z-index-1 p-0">
                            <img src={greetingImage} alt="" width="96" />
                            <div className="ms-n3">
                                <h6 className="mb-1 text-primary">Bienvenido a </h6>
                                <h4 className="mb-0 text-primary fw-bold">
                                    Notificaciones
                                    <span className="text-info fw-medium"> Akasia </span>
                                </h4>
                            </div>
                        </Card.Header>
                    </Card>

                </Col>

                <Col className="col-12 mb-3">

                    <Row>

                        <Col className="col-12">
                            <Card className="h-100">
                                <Card.Body>

                                    <div className="notifications">
                                        <div className="notification-container">
                                            {

                                                <>
                                                    <NotificationSection
                                                        setShowModalSeguimientoLead={setShowModalSeguimientoLead}
                                                        idTipoNotificacion={1}
                                                        setIdLead={setIdLead}
                                                    />
                                                </>


                                            }
                                        </div>
                                    </div>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>

            </Row>


            <ModalSeguimientoLead
                showModal={showModalSeguimientoLead}
                setShowModal={setShowModalSeguimientoLead}
                idLead={idLead}
                setIdLead={setIdLead}
            />
        </>
    );
};

const NotificationSkeleton = () => {
    return (
        <>
            <Row
                style={{ border: 'none' }}
                className={classNames(
                    'p-1 shadow-none  d-flex align-items-center rounded-0',
                    'notification-skeleton'
                )}
            >
                <Col className="col-1 pe-0">
                    <Skeleton circle width={50} height={50} />
                </Col>
                <Col className="col-11 ps-2">
                    <Skeleton height={40} />
                </Col>
            </Row>

            <Row
                style={{ border: 'none' }}
                className={classNames(
                    'p-1 shadow-none  d-flex align-items-center rounded-0',
                    'notification-skeleton'
                )}
            >
                <Col className="col-1 pe-0">
                    <Skeleton circle width={50} height={50} />
                </Col>
                <Col className="col-11 ps-2">
                    <Skeleton height={40} />
                </Col>
            </Row>

            <Row
                style={{ border: 'none' }}
                className={classNames(
                    'p-1 shadow-none  d-flex align-items-center rounded-0',
                    'notification-skeleton'
                )}
            >
                <Col className="col-1 pe-0">
                    <Skeleton circle width={50} height={50} />
                </Col>
                <Col className="col-11 ps-2">
                    <Skeleton height={40} />
                </Col>
            </Row>
        </>

    );
};

NotificationSection.propTypes = {
    setIdLead: PropTypes.func,
    setShowModalSeguimientoLead: PropTypes.func,
};

NotificationItem.propTypes = {
    notification: PropTypes.object,
    setIdLead: PropTypes.func,
    setShowModalSeguimientoLead: PropTypes.func,
};

export default NotificationsPage;
